import { mainAxios as axios } from './axios'


export const stopJob = async (job_uniqid) => {
  let a = axios.delete(`/jobs/${job_uniqid}`,)

  return a;
}
export const deleteFailedJob = async (job_uniqid) => {
  let a = axios.delete(`/jobs/failed/${job_uniqid}`,)

  return a;
}